"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_ROUTES = exports.ROUTES = void 0;
exports.ROUTES = {
    HOME: '/',
    POSTS: '/posts',
    POST_DETAIL: '/posts/$slug',
    CATEGORIES: '/categories',
    CATEGORY_DETAIL: '/categories/$category',
    TAGS: '/tags',
    TAG_DETAIL: '/tags/$tag',
    ABOUT: '/about',
};
exports.API_ROUTES = {
    POSTS: '/data/posts.json',
    POST_DETAIL: '/data/posts/$slug.json',
    CATEGORIES: '/data/categories.json',
    TAGS: '/data/tags.json',
    METADATA: '/data/metadata.json',
};
